import React from 'react'
import MobNewClinicBooking from './Mobile/components/MobClinicBookingSearchWrapper'

const PatClinicConsultBooking = ({ isCaresync, testKey }) => {
  return <MobNewClinicBooking isCaresync={isCaresync} testKey={testKey} />
}

export default PatClinicConsultBooking
